export type Limit = 3000000 | 6000000 | 16000000;
export type Deductible = 0 | 150000 | 350000;
export type Copay = 0 | 0.15 | 0.25;
export type LifeUtilityAddOn = "breeding" | "hunting" | "";

export const MAX_AGE_DOG = 300;
export const MAX_AGE_CAT = 300;
export const MIN_LIFE_LIMIT_CAT = 1500;
export const MIN_LIFE_LIMIT_DOG = 2500;
export const MAX_LIFE_LIMIT_CAT = 20000;
export const MAX_LIFE_LIMIT_DOG = 50000;

export const ipids = [
  {
    limit: 3000000,
    href: "https://docs.lassie.co/ipid/latest/lassie-ipid-brons.pdf",
  },
  {
    limit: 6000000,
    href: "https://docs.lassie.co/ipid/latest/lassie-ipid-silver.pdf",
  },
  {
    limit: 9000000,
    href: "https://docs.lassie.co/ipid/latest/lassie-ipid-silver.pdf",
  },
  {
    limit: 12000000,
    href: "https://docs.lassie.co/ipid/latest/lassie-ipid-silver.pdf",
  },
  {
    limit: 16000000,
    href: "https://docs.lassie.co/ipid/latest/lassie-ipid-guld.pdf",
  },
];

export const prepurchaseInfoInsurance =
  "https://docs.lassie.co/terms-and-conditions/latest/forkopsinformation-hund-och-kattforsakring.pdf";
export const prepurchaseInfoLassie =
  "https://docs.lassie.co/terms-and-conditions/latest/forkopsinformation.pdf";
export const termsAndConditions =
  "https://docs.lassie.co/terms-and-conditions/latest/villkor-hund-och-kattforsakring.pdf";
export const termsAndConditionsOldV5 =
  "https://docs.lassie.co/terms-and-conditions/villkor-hund-och-kattforsakring-juli-2023.pdf";
export const termsAndConditionsOldV4 =
  "https://docs.lassie.co/terms-and-conditions/villkor-hund-och-kattforsakring-juni-2023.pdf";
export const termsAndConditionsOldV3 =
  "https://docs.lassie.co/terms-and-conditions/villkor-hund-och-kattforsakring-januari-2023.pdf";
export const termsAndConditionsOldV2 =
  "https://docs.lassie.co/terms-and-conditions/villkor-hund-och-kattforsakring-maj-2022-v2.pdf";
export const termsAndConditionsOld =
  "https://docs.lassie.co/terms-and-conditions/villkor-hund-och-kattforsakring-januari-2022.pdf";
export const termsAndConditionsOldV1_2 =
  "https://docs.lassie.co/terms-and-conditions/villkor-hund-och-kattforsakring-maj-2022-v1.2.pdf";
